import SmallAssembly from './Modules/SmallAssembly'

const initKnowledgeHubOnLoad = function () {
    let smallTeaserAssemblies = document.querySelectorAll('.js-blog-teaser-assembly--small')
    let bigTeaserAssemblies = document.querySelectorAll('.js-blog-teaser-assembly--big')
    smallTeaserAssemblies.forEach((assembly) => new SmallAssembly(assembly))
    bigTeaserAssemblies.forEach((assembly) => new SmallAssembly(assembly))
}
if (document.readyState !== 'loading') {
    initKnowledgeHubOnLoad()
} else {
    document.addEventListener('DOMContentLoaded', initKnowledgeHubOnLoad)
}
